import * as Yup from 'yup';

export const schema = Yup.object().shape({
  GameJoinApplicationPlayListLabel: Yup.string().required('وارد کردن نام پلی لیست  بازی ها اجباری است'),
});
